document.addEventListener( 'alpine:init', () => {

	Alpine.data( 'frontPageEquipment', () => ({
		featuredIndex    : 0,
		fadingIndices    : [],
		isMd             : false,
		maxOffset          : 0,
		offsetHeight       : 0,
		offsetHeightMid    : 0,
		offsetHeightRight: 0,
		mqMd               : null,
		mqXl               : null,

		swapFeatured( index ) {
			this.fadingIndices = [ this.featuredIndex, index ];
			setTimeout( () => {
				const list  = this.$refs['equipment-list'];
				const nodeA = list.querySelector( `[x-ref='equipment-card-${ this.featuredIndex }']` );
				const nodeB = list.querySelector( `[x-ref='equipment-card-${ index }']` );
				const ph    = document.createElement( 'li' );
				list.insertBefore( ph, nodeB );
				list.insertBefore( nodeB, nodeA );
				list.insertBefore( nodeA, ph );
				ph.remove();
				this.featuredIndex = index;
				this.$store.equipmentPopup.active = null;
				this.$nextTick( () => {
					this.fadingIndices = [];
				});
			}, 150 );
		},

		init() {
			this.mqMd = window.matchMedia( '(min-width: ' + getComputedStyle( document.documentElement ).getPropertyValue( '--breakpoint-md' ).trim() + ')' );
			this.isMd = this.mqMd.matches;
			this.mqMd.addEventListener( 'change', ( e ) => {
				this.isMd = e.matches;
			});
			this.mqXl = window.matchMedia( '(min-width: ' + getComputedStyle( document.documentElement ).getPropertyValue( '--breakpoint-xl' ).trim() + ')' );
			this.recalcMax();
			this.updateOffset();
			window.addEventListener( 'scroll', () => this.updateOffset(), { passive: true });
			new ResizeObserver( () => {
				this.recalcMax(); this.updateOffset();
			}).observe( this.$refs['equipment-card-1'] );
		},

		recalcMax() {
			this.maxOffset = this.mqXl.matches ? this.$refs['equipment-card-1'].offsetHeight + 16 : 0;
		},

		updateOffset() {
			const rect   = this.$refs['equipment-list'].getBoundingClientRect();
			const vh     = window.innerHeight;
			const height = rect.bottom - rect.top;

			const progress = rect.bottom > vh
				? Math.max( 0, Math.min( 1, ( vh - rect.top ) / height ) )
				: 1;

			const lag = ( p, delay ) => Math.max( 0, Math.min( 1, ( p - delay ) / ( 1 - delay ) ) );

			this.offsetHeight      = Math.round( this.maxOffset * ( 1 - progress ) );
			this.offsetHeightMid   = Math.round( this.maxOffset * ( 1 - lag( progress, 0.20 ) ) );
			this.offsetHeightRight = Math.round( this.maxOffset * ( 1 - lag( progress, 0.40 ) ) );
		},
	}) );
});
